import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options'
import { SeFeIndicatorDotModule } from 'se-fe-indicator-dot'
import { SeFeIconModule, seFeIconChevronDown, seFeIconSpotFlatBall, seFeIconSpotServiceBreakdown } from 'se-fe-icon'
import { SeFeListModule } from 'se-fe-list'
import { SeFeMenuModule } from 'se-fe-menu'
import { SeFeToolbarModule } from 'se-fe-toolbar'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { OpenRegistrationFilterComponent } from './open-registration-filter/open-registration-filter.component'
import { OpenRegistrationSearchComponent } from './open-registration-search/open-registration-search.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeChipModule,
    SeFeFormFieldOptionsModule,
    SeFeIndicatorDotModule,
    SeFeIconModule.include([
      seFeIconChevronDown,
      seFeIconSpotFlatBall,
      seFeIconSpotServiceBreakdown,
    ]),
    SeFeListModule,
    SeFeMenuModule,
    SeFeToolbarModule,
    SeFeTranslationsModule,
  ],
  declarations: [
    OpenRegistrationFilterComponent,
    OpenRegistrationSearchComponent,
  ],
  exports: [
    OpenRegistrationFilterComponent,
    OpenRegistrationSearchComponent,
  ],
})
export class SeRegistrationUiFeatureOpenRegistrationListModule {}
